import { Badge } from '@radix-ui/themes'
import type { Ops } from '@willie/schemas'
import { outcomeColor, outcomeLabel, statusColor, statusLabel } from '~/features/index-captures/labels'

interface CaptureStatusBadgeProps {
  status: Ops.IndexCaptures.CaptureStatus
  outcome: Ops.IndexCaptures.CaptureOutcome | null
}

/** The outcome while it still stands; a resolved round reads as resolved whatever it compared to. */
export const CaptureStatusBadge = ({ status, outcome }: CaptureStatusBadgeProps) =>
  outcome && status !== 'resolved' ? (
    <Badge color={outcomeColor[outcome]} variant="soft" size="1">
      {outcomeLabel[outcome]}
    </Badge>
  ) : (
    <Badge color={statusColor[status]} variant="soft" size="1">
      {statusLabel[status]}
    </Badge>
  )

export const ScaleErrorBadge = ({ size = '1' }: { size?: '1' | '2' }) => (
  <Badge color="amber" variant="outline" size={size} title="A factor of ten out — most likely a dropped drum">
    Probable scale error
  </Badge>
)
